var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { useGlobalContext } from '@honeycomb/data';
import { FlexGrid, Stacker, Styler, TypographyBody, TypographyHeading } from '@honeycomb/ui-core';
import { TripadvisorRating } from '../../../tripadvisor/TripadvisorRating';
import { CustomerRating } from '../CustomerRating/CustomerRating';
import { useHotelCustomerRatingSummary } from '../../utils';
import { TrustYouReviewScore } from '../../TrustYouReview/TrustYouReviewScore';
import { parseBoolean } from '../../../../utils';
export function HotelReviewsHeader(_a) {
    var { hotelDetails, onDialogTriggerClick } = _a, other = __rest(_a, ["hotelDetails", "onDialogTriggerClick"]);
    const { resourceStrings: { HOTEL_PAGE_REVIEWS_TITLE }, configSettings: { HideInHouseRatingEstabPage }, } = useGlobalContext();
    const { estabId, customerFeedback, tripadvisorFeedback, trustYouReviewClusterId } = hotelDetails;
    const numberOfReviews = (customerFeedback === null || customerFeedback === void 0 ? void 0 : customerFeedback.numberOfReviews) || 0;
    const summary = useHotelCustomerRatingSummary(numberOfReviews || 0);
    if (!customerFeedback) {
        return null;
    }
    const showCustomerRating = !(trustYouReviewClusterId && parseBoolean(HideInHouseRatingEstabPage));
    return (React.createElement(Styler, Object.assign({}, other),
        React.createElement(FlexGrid, { container: true, flexWrap: "wrap", justifyContent: "space-between", spacing: 3 },
            React.createElement(FlexGrid, null,
                React.createElement(Stacker, { spacing: 2 },
                    React.createElement(Stacker, { direction: "row", alignItems: "center", spacing: 4 },
                        React.createElement(TypographyHeading, { size: "s", color: "text.body", "data-id": "reviews-header" }, HOTEL_PAGE_REVIEWS_TITLE),
                        showCustomerRating && React.createElement(CustomerRating, { customerFeedback: customerFeedback })),
                    React.createElement(TypographyBody, { component: "div", size: "xs", color: "text.light", "data-id": "reviews-summary" }, summary))),
            React.createElement(FlexGrid, null,
                (tripadvisorFeedback === null || tripadvisorFeedback === void 0 ? void 0 : tripadvisorFeedback.numberOfReviews) && (React.createElement(TripadvisorRating, { tripadvisorFeedback: tripadvisorFeedback, onClick: () => onDialogTriggerClick === null || onDialogTriggerClick === void 0 ? void 0 : onDialogTriggerClick('tripadvisor'), "data-id": "trip_advisor_rating", "data-key": estabId })),
                trustYouReviewClusterId && (React.createElement(TrustYouReviewScore, { onClick: () => onDialogTriggerClick === null || onDialogTriggerClick === void 0 ? void 0 : onDialogTriggerClick('trustyou'), clusterId: trustYouReviewClusterId }))))));
}
